export function migrateFeedbackDirectionData(raw) {
  if (!raw || typeof raw !== 'object') {
    return { direction: null, context: '' }
  }

  const direction = raw.direction
  const context = typeof raw.context === 'string' ? raw.context : ''

  if (direction === 'give' || direction === 'receive') {
    return { direction, context }
  }

  if (direction === 'both') {
    return { direction: 'give', context }
  }

  return { direction: null, context }
}
